import { Trans, useTranslation } from 'react-i18next';
import { formatDate } from '~/lib';
import { LocalesType } from '~/types/uiTypes';
import { TransactionType } from '~/types/walletTypes';
import TransactionListLoader from '~myAccount/pages/Wallet/TransactionListLoader';

const TransactionsList = ({
  isLoading,
  transactions,
}: {
  transactions: TransactionType[];
  isLoading: boolean;
}) => {
  const { t, i18n } = useTranslation('app');
  const locale = i18n.language;

  if (isLoading) {
    return <TransactionListLoader />;
  }

  if (!transactions.length) {
    return (
      <div className="flex flex-col justify-center items-center gap-1.5x ">
        <div className="flex element-center w-[48px] h-[48px]">
          <i className="inline-block bg-cover search-remove-icon w-full h-full" />
        </div>
        <div className="flex flex-col  justify-center items-center gap-x ">
          <p className="text-title_4">{t('noTransactionsFound')}</p>
          <p className="text-body_1 text-gray__dark_1">
            {t('editSearchCriteria')}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-2x">
      {transactions.map((transaction, index) => (
        <div
          key={transaction.id}
          className={`flex   flex-col  gap-x justify-between  ${index === transactions.length - 1 ? '' : 'border-b border-gray pb-2x '}  `}
        >
          {Number(transaction.amount) > 0 && (
            <div className="flex justify-between w-full md:justify-start md:gap-2x ">
              <span className="text-link">{t('addedBalance')}</span>
              <p className="text-title_4 text-green_dark">
                <Trans
                  i18nKey="priceValue"
                  t={t}
                  values={{
                    value: `+${transaction.amount}`,
                  }}
                  components={{
                    tag: (
                      <span className="text-body_1 text-black ">
                        placeholder
                      </span>
                    ),
                  }}
                />
              </p>
            </div>
          )}
          {Number(transaction.amount) < 0 && (
            <div className="flex gap-2x">
              <span className="text-link">{t('balanceDeducted')}</span>
              <p className="text-title_4 text-red_dark">
                <Trans
                  i18nKey="priceValue"
                  t={t}
                  values={{
                    value: transaction.amount,
                  }}
                  components={{
                    tag: (
                      <span className="text-body_1 text-black">
                        placeholder
                      </span>
                    ),
                  }}
                />
              </p>
            </div>
          )}

          <span className="text-body_2 text-gray__dark_1">
            {formatDate({
              value: transaction.createdAt,
              format: 'gregorian',
              language: locale as LocalesType,
            })}
          </span>
        </div>
      ))}
    </div>
  );
};

export default TransactionsList;
